import { CurrencyPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { AppResource } from 'src/app/app.resource';
import { CombinedStore } from 'src/app/core/combined.store';

@Component({
  selector: 'app-vyv-summary',
  standalone: true,
  imports: [CurrencyPipe],
  templateUrl: './vyv-summary.component.html',
  styles: [],
})
export class VyvSummaryComponent {
  public resource = inject(AppResource)['resource'];
  store = inject(CombinedStore);

  isNumber(value: string): boolean {
    return value?.trim() !== '' && !isNaN(Number(value));
  }
}
